<template>
  <v-container fluid class="help">
    <v-row>
      <v-col class="text-center">
        <h1>Career Preview Slide</h1>
        <br><br>      
      </v-col>
    </v-row>
    <v-row class="px-4">
      <v-col
        v-for="card in cards"
        :key="card.id"
        class="d-flex child-flex"
        cols="12"
        sm="3"
      >
        <v-card>
          <v-img
          :src="card.src"
          :lazy-src="card.src"
          aspect-ratio="1"
          class="grey lighten-2"
          height="150px"
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <v-card-title>{{card.title}}</v-card-title>
          <v-card-actions>
            <v-btn
              color="orange"
              text
              :href="card.link"
              target="_blank"
            >
              View
            </v-btn>
            </v-card-actions>
        </v-card>
        <br>
      </v-col>
    </v-row>
    <br><br>
    
    
  </v-container>
</template>

<script>
export default {
  data: () => ({
      cards: [
        { 
          id: '0', 
          title: 'The BOSS', 
          src: require('@/assets/img_sales_tool/cp-TERAS-LEGACY-SLIDE-CAREER-PREVIEW-pdf.jpeg'),
          link: 'https://teraslegacy.com/wp-content/uploads/2022/07/THE-BOSS-24-June-2022.pptx', 
        },
        { 
          id: '1', 
          title: 'Teras Formula G15', 
          src: require('@/assets/img_sales_tool/cp-TERAS-LEGACY-SLIDE-CAREER-PREVIEW-pdf.jpeg'),
          link: 'https://teraslegacy.com/wp-content/uploads/2022/01/TERAS-FORMULA-G15.pdf', 
        },
        { 
          id: '2', 
          title: 'Property Legacy Career Preview', 
          src: require('@/assets/img_sales_tool/cp-TERAS-LEGACY-SLIDE-CAREER-PREVIEW-pdf.jpeg'),
          link: 'https://teraslegacy.com/wp-content/uploads/2021/12/Property-Legacy-Career-Preview.pdf',  
        },
        
      ],
  }),
}
</script>
